import { useCallback } from 'react'

import { useAddFileMutation } from '@/core/services/file'

export function useSavePatientFile(patientId: string) {
  const [addFile] = useAddFileMutation()

  const saveFile = useCallback(
    async (file: File) => {
      await addFile({
        file,
        objectType: 'patient',
        objectId: patientId,
      }).unwrap()
    },
    [patientId, addFile]
  )

  return { saveFile }
}
